import { platform } from '../platform';

/**
 * Conta os caracteres e as quebras de linha de um texto.
 * Para IOS < 17, as quebras de linha são contadas como dois caracteres.
 *
 * @param text texto para medir
 *
 * @category String
 *
 * @example
 * ```ts
 * import { textLength } from '@ids/tools';
 *
 * textLength(`Porto
 * Alegre`);
 * // 13 - IOS
 * // 12 - Android
 * ```
 */
export const textLength = (text = '') => {
  const { osVersion } = platform;

  if (platform.os === 'IOS') {
    const iphoneVersion = osVersion.match(/(\d+)/);

    if (iphoneVersion && parseInt(iphoneVersion[0], 10) < 17) {
      return text.replace(/(\r\n|\r|\n)/g, '  ').length;
    }
  }

  return text.length;
};
